import React from "react";

export default function NotFoundPage() {
    return (
        <section className="section-pad">
            <div className="container-editorial text-center">
                <div className="eyebrow mb-4">// 404 — wrong doorway</div>
                <h1 className="display-1 text-white mb-6">This <span className="text-[#FF2A2A]">experience</span> doesn't exist.</h1>
                <p className="body-lg max-w-lg mx-auto">Try the nav above — the moments you're looking for are probably a click away.</p>
            </div>
        </section>
    );
}
